import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  DialogMessage,
  IconNames,
  IconWithBackground,
  useTheme
} from "@tvg/design-system";
import { closeModal } from "@tvg/sh-lib-my-bets/utils/general";
import { onReturnBettingGtm } from "@tvg/sh-lib-my-bets/utils/gtm";
import {
  getEmptyStateTitle,
  getEmptyStateMessage
} from "@tvg/sh-lib-my-bets/utils/service";

import { useLocation } from "react-router-dom";
import { useNavigate } from "@tvg/custom-hooks";
import {
  getSelectedSettledTab,
  getSelectedTab
} from "@tvg/sh-lib-my-bets/redux/selectors";
import { EmptyCase } from "./styled-components";

const MyBetsEmptyState = () => {
  const theme = useTheme();
  const selectedTab = useSelector(getSelectedTab);
  const selectedSettledTab = useSelector(getSelectedSettledTab);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useNavigate();
  const emptyStateTitle = getEmptyStateTitle(selectedTab, selectedSettledTab);
  const emptyMessage = getEmptyStateMessage(selectedTab);

  return (
    <EmptyCase theme={theme}>
      <DialogMessage
        title={emptyStateTitle}
        description={emptyMessage}
        p="space-4"
        illustration={
          <IconWithBackground
            mainIcon={{
              name: "info" as IconNames,
              lineColor: "blue_accent.600",
              backgroundColor: "blue_accent.200"
            }}
          />
        }
      />
      <Button
        variant="secondary"
        isStretched
        onPress={() => {
          onReturnBettingGtm(selectedTab, selectedSettledTab);
          closeModal(dispatch, location, history);
        }}
        qaLabel="myBets-empty-case-button"
      >
        Return to betting
      </Button>
    </EmptyCase>
  );
};

export default MyBetsEmptyState;
